export default class SavingsData {
    constructor(fuelECA, fuelNonECA, fuelOverall, time, tce) {
        this.fuelECA = fuelECA,
            this.fuelNonECA = fuelNonECA,
            this.fuelOverall = fuelOverall,
            this.time = time,
            this.tce = tce
    }
}